export enum InfinitySelectDataType {
  LoincBiomarker = "loincBiomarker",
  samples = "samples",
}
